import { isDefined } from '@stillmandigital/common';
import { isArray } from 'lodash';
import { SelectionModel } from '@shared/components/multi-select-with-exclude/multi-select-with-exclude.component';

export function booleanToUrlParam(value?: boolean): string | undefined {
  return value ? 'true' : undefined;
}

export function urlParamToBoolean(param?: string): boolean {
  return param === 'true';
}

export function urlParamToNumber(param?: string): number | undefined {
  const value = param?.toString()?.trim();

  return value && value !== 'NaN' ? Number(param) : undefined;
}

export function urlParamToNumberArray(param?: string | string[]) {
  if (!isDefined(param)) {
    return undefined;
  }

  return isArray(param) ? param.map(Number) : [Number(param)];
}

export function urlParamToArray<T>(param?: string | string[]) {
  if (!isDefined(param)) {
    return undefined;
  }

  return isArray(param) ? (param as Array<T>) : [param as T];
}

export function asUndefinedForEmptyString<T>(val: T | '') {
  if (val === '') {
    return undefined;
  }

  return val;
}

export function toSelectionModel(includeIds?: string | string[], excludeIds?: string | string[]): SelectionModel {
  return asUndefinedForEmptyString(excludeIds)
    ? {
        exclude: urlParamToNumberArray(excludeIds),
      }
    : {
        include: urlParamToNumberArray(includeIds),
      };
}

export function buildQueryParams(params: {
  [key: string]: string | number | boolean | Array<string> | Array<number> | Array<boolean>;
}): string {
  return Object.entries(params)
    .filter(([_, value]) => isDefined(value))
    .map(([key, value]) =>
      Array.isArray(value)
        ? value.map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join('&')
        : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&');
}
